import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Frac, FracStage } from '~lmo/models/frac.model';
import { LmoFracsService } from '~lmo/services';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-home-update-button',
  styleUrls: ['./lmo-frac-home-update-button.component.scss'],
  templateUrl: './lmo-frac-home-update-button.component.html',
})
export class LmoFracHomeUpdateButtonComponent implements OnInit {
  public currentFracCurrentStage$: Observable<FracStage>;
  public currentFrac$: Observable<Frac>;
  constructor(private fracService: LmoFracsService) {}

  public ngOnInit() {
    this.currentFracCurrentStage$ = this.fracService.currentFracCurrentStage$;
    this.currentFrac$ = this.fracService.currentFrac$;
  }
}
